/* 
 * 接口统一集成模块
 */
import * as login from './moudules/login'
import * as user from './moudules/user'
import * as dept from './moudules/dept'
import * as role from './moudules/role'
import * as menu from './moudules/menu'
import * as dict from './moudules/dict'
import * as log from './moudules/log'
import * as common from './moudules/common'
import * as table from './moudules/table'
import * as workflow from './moudules/workflow'
import * as im from './moudules/im' //消息
import * as component from './moudules/component' //Vue 拖拽组件模块接口 sjg
import * as wisdom from './moudules/wisdom';
import * as leave from './leave/leave.js'
import * as wxMenu from './moudules/wxMenu.js'
// 默认全部导出
export default {
    login,
    user,
    dept,
    role,
    menu,
    dict,
    log,
    common,
    table,
    workflow,
    wisdom,
    im,
    component,
    leave,
    wxMenu,
}



// WEBPACK FOOTER //
// ./src/http/api.js